import { Button, Divider, Layout, Modal, Segmented } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import React, { useState } from "react";
import { GrMapLocation } from "react-icons/gr";
import { MdDeleteOutline, MdOutlineUnarchive } from "react-icons/md";
import { SiFsecure } from "react-icons/si";
import { TbHistoryToggle } from "react-icons/tb";
import Tarix from "./Tarix";
import Arxiv from "./Arxiv";
import Verify from "./Verify";
import Kafilliklar from "./Kafilliklar";
import axiosInstance from "../../axiosInstance/AxiosInstance";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import { CustomersStore } from "../../../Stores/Customers/CustomersStore";
import { useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../../MessageProvider/MessageProvider";
import Notify from "./Notify";

export default function SettingsModal({ openSettings, setOpenSettings }) {
  // const { fetchData } = OneCustomer();
  let [sections, setSections] = useState("YUK XATLARI");
  const { data, loading, error, fetchData } = CustomersStore();
  let [parts, setParts] = useState(1);
  let navigate = useNavigate();
  const { id } = useParams();
  const messageApi = useMessage();

  let delUser = async () => {
    try {
      let { data } = await axiosInstance.delete("/api/customers/" + id);

      console.log(data);

      messageApi.open({
        type: "success",
        content: data.message,
      });
      fetchData();
      navigate("/customers", { replace: true });
    } catch (error) {
      // console.log(error);
    } finally {
      console.log("true");
    }
  };
  return (
    <Modal
      width={"100%"}
      style={{ top: "10px", width: "100%" }}
      title="Sozlamalar"
      open={openSettings}
      //   loading={loadVagon}
      onOk={() => {
        setOpenSettings(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpenSettings(false);
      }}
      footer={[]}
    >
      <div>
        <Layout
          style={{
            padding: "4px 0",
            background: "#fff",
            borderRadius: "10px",
          }}
        >
          <Sider
            style={{
              background: "#fff",
            }}
            width={200}
          >
            <div className="h-full flex flex-col justify-between  gap-2">
              <div className="flex flex-col  gap-2">
                <div>
                  {/* <h2 className="text-[12px] bold ">
                  Mijoz kafil bo'lgan ishalar!
                </h2> */}
                  <Button
                    size="large"
                    className="w-[100%] flex justify-start"
                    onClick={() => {
                      setParts(1);
                    }}
                    icon={<SiFsecure className="font-[30px]" />}
                    variant="filled"
                    color={parts == 1 ? "primary" : "default"}
                  >
                    Kafilliklar
                  </Button>
                </div>

                <div>
                  {/* <h2 className="text-[12px] bold ">
                  Mijozni barcha tarixini ko'rish!
                </h2> */}
                  <Button
                    size="large"
                    onClick={() => {
                      setParts(2);
                    }}
                    className="w-[100%] flex justify-start"
                    icon={<TbHistoryToggle className="font-[30px]" />}
                    color={parts == 2 ? "primary" : "default"}
                    variant="filled"
                  >
                    Tarix
                  </Button>
                </div>

                <div>
                  {/* <h2 className="text-[12px] bold ">
                  Mijozni barcha hissoblarini arxivlash!
                </h2> */}
                  <Button
                    size="large"
                    className="w-[100%] flex justify-start"
                    icon={<MdOutlineUnarchive className="font-[30px]" />}
                    color={parts == 3 ? "primary" : "default"}
                    variant="filled"
                    onClick={() => {
                      setParts(3);
                    }}
                  >
                    Arxivlash
                  </Button>
                </div>
                <div>
                  {/* <h2 className="text-[12px] bold ">
                  Mijozni barcha hissoblarini arxivlash!
                </h2> */}
                  <Button
                    size="large"
                    className="w-[100%] flex justify-start"
                    icon={<MdOutlineUnarchive className="font-[30px]" />}
                    color={parts == 5 ? "primary" : "default"}
                    variant="filled"
                    onClick={() => {
                      setParts(5);
                    }}
                  >
                    Notification
                  </Button>
                </div>
                <div>
                  {/* <h2 className="text-[12px] bold ">
                  Mijozni barcha hissoblarini arxivlash!
                </h2> */}
                  <Button
                    size="large"
                    className="w-[100%] flex justify-start"
                    icon={
                      <img
                        src="https://www.notion.so/icons/verified_blue.svg?mode=dark"
                        width={25}
                        height={25}
                      />
                    }
                    color={parts == 4 ? "primary" : "default"}
                    variant="filled"
                    onClick={() => {
                      setParts(4);
                    }}
                  >
                    Verify
                  </Button>
                </div>
              </div>
              <div>
                <h2 className="text-[12px] bold ">Etiborli bo'ling!</h2>
                <Button
                  size="large"
                  className="w-[100%] flex justify-start"
                  icon={<MdDeleteOutline className="font-[30px]" />}
                  color="danger"
                  variant="filled"
                  onClick={() => {
                    delUser();
                  }}
                >
                  O'chirish
                </Button>
              </div>
            </div>
          </Sider>
          <Content
            style={{
              padding: "0 24px",
              minHeight: 280,
            }}
          >
            {parts == 1 ? <Kafilliklar /> : ""}
            {parts == 2 ? <Tarix /> : ""}
            {parts == 3 ? <Arxiv setOpenSettings={setOpenSettings} /> : ""}
            {parts == 4 ? <Verify /> : ""}
            {parts == 5 ? <Notify /> : ""}
          </Content>
        </Layout>
      </div>
    </Modal>
  );
}
